<div class="footer" aria-label="footer" *ngIf="shouldShowFooter()">
  <div class="brand">Virgin Money {{ getCurrentYear() }}</div>

  <div class="links">
    <a class="link-item" rdOpenInNewTab [href]="faqsUrl">{{
      'wl.vma.footer.faq' | translate
    }}</a>
    <a class="link-item" rdOpenInNewTab [href]="tncsUrl">{{
      'wl.vma.footer.terms_and_conditions' | translate
    }}</a>
    <a class="link-item" rdOpenInNewTab [href]="privacyPolicyUrl">{{
      'wl.vma.footer.privacy_policy' | translate
    }}</a>
    <a class="link-item" rdOpenInNewTab [href]="contactUsUrl">{{
      'wl.vma.footer.contact_us' | translate
    }}</a>
  </div>
</div>
